export default __webpack_public_path__ + "static/media/skoda.623a8e11.webp";